import React, { useState, useEffect } from 'react';

// Configuración de testimonios - fácil de modificar
const TESTIMONIALS = [
  {
    id: 1,
    message: "LEXIS se ha convertido en un aliado estratégico para la evolución de nuestras soluciones digitales. Su equipo ha garantizado un mantenimiento sólido, un desarrollo confiable y una migración sin fricciones, permitiéndonos ofrecer a nuestros clientes una experiencia más ágil y moderna.",
    name: "Nicolás Guevara-Ruales",
    position: "Asociado, HEKA",
    image: "/testimonials/rodrigo-orellana.jpg", // Placeholder - replace with actual image
    rating: 5
  }
];

const TestimonialsSection: React.FC = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  // Auto-advance carousel every 6 seconds
  useEffect(() => {
    if(TESTIMONIALS.length === 1) return;
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentTestimonial((prev) => (prev + 1) % TESTIMONIALS.length);
        setIsVisible(true);
      }, 800); // Longer wait for smoother transition
    }, 6000); // Slower auto-advance

    return () => clearInterval(interval);
  }, []);


  const current = TESTIMONIALS[currentTestimonial];

  return (
    <section className="w-full bg-white">
      <div className="px-6 md:px-8 bg-[#F6F7F9] rounded-3xl">
        {/* Wrapper con fondo y bordes redondeados */}
        <div className="mx-auto max-w-7xl px-6 py-10 md:px-10 md:py-14 shadow-sm">
          {/* Badge */}
          <div className="mb-6 flex justify-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 shadow-sm">
              <img src="/icons/testimonials.svg" alt="Testimoniales" className="h-4 w-4" />
              Testimoniales
            </span>
          </div>

          {/* Título */}
          <h2 className="text-center text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl mb-4">
            No confíes solo en nuestra palabra
          </h2>
          
          {/* Subtítulo */}
          <p className="text-center text-slate-600 mb-12">
            Nuestros clientes son nuestros mejores embajadores.
          </p>

          {/* Testimonial Card */}
          <div className="relative max-w-7xl mx-auto">
            <div 
              className={`transition-all duration-800 ease-in-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            >
              <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm ring-1 ring-slate-100 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer">
                {/* Rating Stars */}
                <div className="flex justify-center mb-8">
                  <img 
                    src="/rating.svg" 
                    alt="5 estrellas" 
                    className="h-6 w-auto"
                  />
                </div>

                {/* Testimonial Text */}
                <blockquote className="text-center">
                  <p className="text-xl md:text-2xl font-medium text-slate-900 leading-relaxed mb-8">
                    "{current.message}"
                  </p>
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center justify-center space-x-4">
                  <div className="flex-shrink-0">
                    <img
                      className="h-12 w-12 rounded-full object-cover ring-2 ring-slate-200"
                      src={current.image}
                      alt={current.name}
                      onError={(e) => {
                        // Fallback to a placeholder if image fails to load
                        const target = e.target as HTMLImageElement;
                        target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(current.name)}&background=1A8A98&color=fff&size=48`;
                      }}
                    />
                  </div>
                  <div className="text-center">
                    <div className="font-semibold text-slate-900">{current.name}</div>
                    <div className="text-sm text-slate-600">{current.position}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
